import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { SupportingDocumentDTO } from 'app/model/supporting-document-dto';
import { SupportingDocumentBean } from 'app/model/supporting-document-bean';
import { UrlConfigService } from './url-config.service';

@Injectable({
  providedIn: 'root'
})
export class SupportingDocumentService {
  // url = environment.SERVER_URL;
  token = '';
  TOKEN = "token";
  url: string;
  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getSupportingDocumentList(supportingDocumentDto: SupportingDocumentDTO) {
    return this.http.post(`${this.url}supp-document-upload/list`, supportingDocumentDto);
  }
  saveComments(supportingDocumentDto: SupportingDocumentDTO) {
    return this.http.post(`${this.url}supp-document-upload/save-comments`, supportingDocumentDto);
  }
  deleteSupportingDocument(supportingDocumentBean: SupportingDocumentBean) {
    return this.http.post(`${this.url}supp-document-upload/delete`, supportingDocumentBean);
  }

  downloadSupportingDoc(supportingDocumentDto: SupportingDocumentDTO) {

    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };

    return this.http.post(`${this.url}supp-document-upload/download`, supportingDocumentDto, httpOptions);
  }

  getSupportingDocumentDetails(supportingDocumentDto: SupportingDocumentDTO) {
    return this.http.post(`${this.url}supp-document-upload/get-supp-doc-details`, supportingDocumentDto);
  }


}
